module.exports = __webpack_public_path__ + "img/logo-dark.4cfeb3ef.png";